<template>
  <div class="template-container">
    <el-tabs class="mt-3" v-model="type" @tab-click="handleTabClick" type="card">
      <el-tab-pane  :label="$t('resourceManage.resource')" name="resource"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.acceleration')" name="acceleration"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.traffic')" name="traffic"></el-tab-pane>
      <el-tab-pane  :label="$t('resourceManage.order')" name="order"></el-tab-pane>

    </el-tabs>
    <div class="action-bar">
      <el-button type="primary" size="medium" @click="handleAddResource">{{ $t('trafficList.add') }}</el-button>
    </div>
    <template>
      <el-form inline ref="form" :model="searchQuery" label-width="100px">

        <el-form-item :label="$t('trafficList.accelerationName')" prop="resource_id">
          <el-select v-model="searchQuery.acceleration_name" clearable :placeholder="$t('trafficList.selectAcceleration')">
            <el-option
                v-for="item in accelerationList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('accelerationList.resourceName')" prop="resource_id">
          <el-select v-model="searchQuery.resource_name" clearable :placeholder="$t('trafficList.selectResource')">
            <el-option
                v-for="item in resourceList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mb-0">
          <el-button type="info" @click="handleSearch" size="small">{{$t('system.search')}}</el-button>
          <el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
        :data="trafficList"
        border
        v-loading="loading"
        style="width: 100%">
      <el-table-column prop="id" :label="$t('trafficList.id')" width="80" align="center"></el-table-column>
      <el-table-column prop="size" :label="$t('trafficList.size')" min-width="100"></el-table-column>
      <el-table-column prop="price" :label="$t('trafficList.price')" min-width="100"></el-table-column>
      <el-table-column prop="acceleration_name" :label="$t('trafficList.accelerationName')" min-width="130"></el-table-column>
      <el-table-column prop="resource_name" :label="$t('trafficList.resourceName')" min-width="130"></el-table-column>
      <el-table-column prop="status" :label="$t('trafficList.status')" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? $t('resourceList.enabled') : $t('resourceList.disabled') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('resourceList.operation')" width="180" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEditResource(scope.row)">{{ $t('resourceList.edit') }}</el-button>
          <el-button type="text" size="small" class="delete-btn" @click="handleDeleteResource(scope.row)">{{ $t('resourceList.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 表单对话框 -->
    <el-dialog
        :title="dialogType === 'add' ? $t('trafficList.add') : $t('trafficList.edit')"
        :visible.sync="dialogVisible"
        width="500px"
        append-to-body
        @close="resetForm">
      <el-form :model="trafficForm" :rules="formRules" ref="trafficForm" label-width="100px">
<!--        <el-form-item :label="$t('trafficList.size')" prop="size">-->
<!--          <el-input v-model="trafficForm.size" :placeholder="$t('trafficList.requireSize')"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item :label="$t('trafficList.size')" prop="size">
          <el-input placeholder="请输入内容" v-model.number="trafficForm.sizeValue" class="input-with-select">
            <el-select
                v-model="trafficForm.sizeUnit"
                slot="append"
                placeholder="请选择"
                style="width: 100px"
                @change="$refs.trafficForm.validateField('size')">
              <el-option label="GB" value="GB"></el-option>
              <el-option label="TB" value="TB"></el-option>
              <el-option label="PB" value="PB"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('trafficList.accelerationName')" prop="acceleration_id">
          <el-select v-model="trafficForm.acceleration_id" placeholder="请选择">
            <el-option
                v-for="item in accelerationList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('trafficList.price')" prop="price">
          <el-input v-model="trafficForm.price" :placeholder="$t('trafficList.requirePrice')"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="trafficForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ResourceType',
  data() {
    return {
      value:'',
      type: 'traffic',
      // 表格数据
      trafficList: [],
      accelerationList:[],
      resourceList:[],
      // 加载状态
      loading: false,
      // 搜索关键词
      searchQuery: {},
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      // 表单对话框可见性
      dialogVisible: false,
      // 对话框类型: add-新增, edit-编辑
      dialogType: 'add',
      // 表单数据
      trafficForm: {
        id: null,
        size: '',
        acceleration_id: '',
        sizeValue: '',
        sizeUnit: 'GB',
        status: 1,
        price: '',
      },
      // 表单校验规则
      formRules: {
        size: [
          {
            validator: (rule, value, callback) => {
              if (!this.trafficForm.sizeValue || !this.trafficForm.sizeUnit) {
                callback(new Error("请输入完整的大小和单位"));
              } else if (isNaN(this.trafficForm.sizeValue)) {
                callback(new Error("必须为数字值"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        price: [
          { required: true, message: "请输入价格", trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error("请输入价格"));
              } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                callback(new Error("请输入有效的金额格式（如 10 或 10.99）"));
              } else if (Number(value) <= 0) {
                callback(new Error("价格必须大于0"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        acceleration_id: [
          { required: true,message : "请选择关联的资源类型",trigger : 'change' }
        ],
        status: [
          { required: true, message: "请选择状态", trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getAccelerationList()
    this.getTrafficList()
    this.getResourceList()
  },
  methods: {
    //获取流量包表
    getTrafficList(){
      const params = {
        page: this.pagination.currentPage,
        limit: this.pagination.pageSize,
        search: this.searchQuery
      }
      this.axios.post('/admin/data/trafficList',params,{
        token : true
      }).then(res => {
        if(res.status === 200 && res.data && res.data.code === 1){
          this.trafficList = res.data.data.list.list
          this.pagination.total = res.data.data.list.total
        }else {
          this.$message.error(res.msg || this.$t('trafficList.getTrafficError'))
        }
      }).catch(error => {
        this.$message.error(error || this.$t('trafficList.getTrafficError'))
      })
    },
    //获取资源列表
    getAccelerationList() {
      this.loading = true
      this.axios.post('/admin/data/getAllAcceleration', {}, {
        token: true
      }).then(res => {
        const { status, msg, data } = res
        if (status === 200 && data && data.code === 1){
          this.accelerationList = data.data.list
        } else {
          this.$message.error(msg || this.$t('accelerationList.fetchError'))
          this.accelerationList = []
        }
        this.loading = false
      }).catch(error => {
        console.error('获取资源列表失败:', error)
        this.$message.error(this.$t('resource.fetchError'))
        this.loading = false
        this.accelerationList = []
      })
    },
    getResourceList(){
      this.axios.post('/admin/data/getAllResource',{},{
        token : true
      }).then(res => {
        const {data , msg , status} = res
        if(status === 200 && data && data.code === 1){
          this.resourceList = data.data.list
        }else {
          this.$message.error(msg)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },


    // 处理搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.getTrafficList()
    },
    // 重置搜索条件
    clearSearch() {
      this.searchQuery = {
        acceleration_name: '',
        resource_name: ''
      }
      this.handleSearch()  // 重置后重新加载数据
    },

    // 处理页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getTrafficList()
    },

    // 处理每页条数变化
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.getTrafficList()
    },

    // 处理添加资源
    handleAddResource() {
      this.dialogType = 'add'
      this.dialogVisible = true
      this.resetForm()
    },

    // 处理编辑资源
    handleEditResource(row) {
      this.dialogType = 'edit'
      this.dialogVisible = true
      const sizeMatch = row.size.match(/^(\d+)(GB|TB|PB)$/i)
      const sizeValue = sizeMatch ? sizeMatch[1] : ''
      const sizeUnit = sizeMatch ? sizeMatch[2].toUpperCase() : 'GB'
      this.trafficForm = {
        ...row,
        sizeValue: sizeValue,
        sizeUnit: sizeUnit
      }

    },

    // 处理删除资源
    handleDeleteResource(row) {
      this.$confirm(this.$t('trafficList.deleteConfirm'), this.$t('system.prompt'), {
        confirmButtonText: this.$t('system.confirm'),
        cancelButtonText: this.$t('system.cancel'),
        type: 'warning'
      }).then(() => {
        this.axios.post('/admin/data/deleteTraffic', {
          id: row.id
        }, {
          token: true
        }).then(res => {
          console.log(res.data)
          if (res.status === 200) {
            this.$message.success(res.data.msg || this.$t('resource.deleteSuccess'))
            this.getTrafficList()
          } else {
            this.$message.error(res.data.msg || this.$t('resource.deleteError'))
          }
        }).catch(error => {
          console.error('删除资源失败:', error)
          this.$message.error(this.$t('resource.deleteError'))
        })
      }).catch(() => {
        this.$message.info(this.$t('trafficList.cancelDelete'))
      })
    },

    // 提交表单
    submitForm() {
      this.loading = true
      this.$refs.trafficForm.validate((valid) => {
        if (valid) {
          this.trafficForm.size = `${this.trafficForm.sizeValue}${this.trafficForm.sizeUnit}`;
          const apiUrl = this.dialogType === 'add'
              ? '/admin/data/addTraffic'
              : '/admin/data/editTraffic'
          this.axios.post(apiUrl, this.trafficForm, {
            token: true
          }).then(res => {
            if (res.status === 200 && res.data.code === 1) {
              this.$message.success(res.data.msg ||
                  (this.dialogType === 'add'
                      ? this.$t('resource.addSuccess')
                      : this.$t('resource.editSuccess')))
              this.dialogVisible = false
              this.getTrafficList()
            } else {
              this.$message.error(res.msg ||
                  (this.dialogType === 'add'
                      ? this.$t('resource.addError')
                      : this.$t('resource.editError')))
            }
          }).catch(error => {
            console.error('操作失败:', error)
            this.$message.error(
                this.dialogType === 'add'
                    ? this.$t('resource.addError')
                    : this.$t('resource.editError'))
          }).finally(() => {
            this.loading = false
          })
        }
      })

    },

    // 重置表单
    resetForm() {
      if (this.$refs.trafficForm) {
        this.$refs.trafficForm.resetFields()
      }
      this.trafficForm = {
        id: null,
        size: '',
        acceleration_id: '',
        status: 1

      }
    },
    // 处理标签页点击
    handleTabClick(tab) {
      const routeMap = {
        resource: '/cdn/resourceManage',
        acceleration: '/cdn/accelerationManage',
        traffic:'/cdn/trafficManage',
        order:'/cdn/orderManage'
      }
      if (routeMap[tab.name] && this.$route.path !== routeMap[tab.name]) {
        this.$router.push(routeMap[tab.name])
      }
    },
  }
}
</script>

<style scoped>
.template-container {
  padding: 20px;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}

.search-input {
  width: 300px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.delete-btn {
  color: #F56C6C;
}
</style>